import { BulkAction, Dialog, Pagination, TabActionDialog } from "@saleor/types";
import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { TabValuesEnum } from "./utils/filters";

export const dropOffSectionUrl = "/drop-off";
export const dropOffListPath = `${dropOffSectionUrl}`;
export const dropOffCreateTemplate = dropOffSectionUrl + "/create";
export const dropOffEditPage = dropOffSectionUrl + "/edit";

export type DropOffListUrlDialog = TabActionDialog | "assign-task-area";

export type DropOffListUrlQueryParams = BulkAction &
  Dialog<DropOffListUrlDialog> &
  Pagination & {
    mall?: string;
    tab?: TabValuesEnum;
    id: string;
    step?: number;
  };

export const dropOffViewPageUrl = (
  params?: DropOffListUrlQueryParams
): string => {
  const dropOffViewPageList = dropOffListPath;
  if (params === undefined) {
    return dropOffViewPageList;
  } else {
    return urlJoin(dropOffViewPageList, "?" + stringifyQs(params));
  }
};

export const dropOffSetupNewMallUrl = (params?: any): string => {
  const dropOffSetupNewMallList = dropOffCreateTemplate;
  if (params === undefined) {
    return dropOffSetupNewMallList;
  } else {
    return urlJoin(dropOffSetupNewMallList, "?" + stringifyQs(params));
  }
};

export const dropOffListUrl = (params?: any): string => {
  const dropOffList = dropOffListPath;
  if (params === undefined) {
    return dropOffList;
  } else {
    return urlJoin(dropOffList, "?" + stringifyQs(params));
  }
};

export const dropOffPath = (id: string) => urlJoin(dropOffListPath, id);
export const dropOffEditPath = (id: string) => urlJoin(dropOffEditPage, id);

export const dropOffUrl = (id: string, params?: DropOffListUrlQueryParams) =>
  dropOffPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
